import { Book, Check } from "@mui/icons-material";
import { Box, Typography } from "@mui/material";
import { AgGridReact } from "ag-grid-react";
import React, { useMemo, useState } from "react";
import { toast } from "react-toastify";
import {
  bookmarkDrug,
  giveDrugToPatient,
  removeAdvice,
  removeDrugInBookmark,
} from "../../../../api/area";
import BookmarkIcon from "../../../../assets/SVG/bookmarkIcon";
import TrashIcon from "../../../../assets/SVG/trashIcon";
import BookmarkDrugs from "./bookmarkDrugs";

export default function TableUserDrug({
  rowData,
  notDelivered,
  handleClick,
  areaId,
  parvandeh,
  setRowData,
  bookmark,
  gridRef,
}) {
  // console.log(rowData);

  const [colDefs] = useState([
    {
      headerName: "ردیف",
      valueGetter: (params) => params.node.rowIndex + 1,
      width: 100,
    },
    {
      field: "patient.name",
      headerName: "نام و نام خانوادگی",
      width: 200,
      // cellRenderer: (x) => {
      //   return (
      //     <Box display="flex" alignItems="center">
      //       <Typography fontFamily="Shabnam">
      //         {x.data?.patient?.name}
      //       </Typography>
      //     </Box>
      //   );
      // },
    },
    {
      field: "experiment",
      headerName: "کد ملی",
      width: 200,
      cellRenderer: (x) => {
        return (
          <Box display="flex" alignItems="center">
            <Typography fontFamily="Shabnam">
              {x.data?.patient?.identifier}
            </Typography>
          </Box>
        );
      },
    },
    {
      field: "experiment",
      headerName: "بیمه",
      width: 200,
      cellRenderer: (x) => {
        return (
          <>
            <Typography fontFamily="Shabnam">
              {x?.data?.patient?.insurance === "TAKMIL"
                ? "تکمیلی"
                : x?.data?.patient?.insurance === "MILITARY"
                ? "نیروهای مسلح"
                : x?.data?.patient?.insurance === "TAMIN"
                ? "تامین اجتماعی"
                : x?.data?.patient?.insurance === "SALAMAT"
                ? "سلامت"
                : "ندارد "}{" "}
            </Typography>
          </>
        );
      },
    },
    {
      field: "drugName",
      headerName: "نام دارو",
      width: 200,
    },
    // {
    //   field: "drugName",
    //   headerName: "عملیات",
    //   width: 200,
    //   cellRenderer: (x) => {
    //     return (
    //       <Box
    //         bgcolor={"#2C685C"}
    //         color="white"
    //         borderRadius={"9px"}
    //         height="29px"
    //         display="flex"
    //         alignItems={"center"}
    //         gap="10px"
    //         p="5px"
    //         sx={{ cursor: "pointer" }}
    //         onClick={() => {
    //           giveDrugToPatient(areaId, x.data?.id)
    //             .then(() => {})
    //             .catch(() => {});
    //         }}
    //       >
    //         <Check />
    //         <Typography color="white" fontFamily="Shabnam">
    //           {"تحویل دارو"}
    //         </Typography>
    //       </Box>
    //     );
    //   },
    // },
  ]);
  const [colDefs1] = useState([
    {
      headerName: "ردیف",
      valueGetter: (params) => params.node.rowIndex + 1,
      width: 100,
    },
    // {
    //   field: "experiment",
    //   headerName: "نام و نام خانوادگی",
    //   width: 200,
    //   cellRenderer: (x) => {
    //     return (
    //       <Box display="flex" alignItems="center">
    //         <Typography fontFamily="Shabnam">
    //           {x.data?.patient?.name}
    //         </Typography>
    //       </Box>
    //     );
    //   },
    // },

    {
      field: "drugName",
      headerName: "نام دارو",
      width: 200,
    },
    {
      field: "suggestCount",
      headerName: "تعداد",
      width: 200,
    },
    {
      field: "dose",
      headerName: " تعداد تحویل",
      width: 100,
      cellRenderer: (x) => {
        return (
          <Box display="flex" alignItems="center">
            <input
              style={{
                width: "50px",
                height: "30px",
                border: "none",
                boxShadow: "0px 1px 2px 0px #00000014",
                borderRadius: "9px",
              }}
              className="inputPresian"
              value={x.data.giveCount}
              onChange={(e) => x.setValue(e.target.value)}
            />
          </Box>
        );
      },
    },
    {
      field: "useTimeFa",
      headerName: "زمان مصرف",
      width: 200,
    },
    {
      field: "howToUseFa",
      headerName: "طریقه مصرف",
      width: 200,
    },
    {
      field: "amountOfUseFa",
      headerName: "مقدار مصرف",
      width: 200,
    },

    {
      field: "dose",
      headerName: "عملیات",
      width: 280,
      cellRenderer: (x) => {
        return (
          <Box display="flex" gap="10px" alignItems="center">
            <Box
              bgcolor={"#2C685C"}
              color="white"
              borderRadius={"9px"}
              height="29px"
              display="flex"
              alignItems={"center"}
              gap="10px"
              p="5px"
              sx={{ cursor: "pointer" }}
              onClick={() => {
                if (!bookmark) {
                  giveDrugToPatient(areaId, x.data?.id, {
                    amount: Number(x.value),
                    description: "",
                  })
                    .then(() => {
                      toast.success("تحویل داده شد");
                    })
                    .catch(() => {});
                } else {
                  giveDrugToPatient(areaId, x.data?.id, {
                    amount: Number(x.value),
                    description: "",
                  })
                    .then(() => {
                      toast.success("تحویل داده شد");
                    })
                    .catch(() => {});
                }
                //   console.log(x.data?.suggestCount);
              }}
            >
              <Typography color="white" fontFamily="Shabnam">
                {!bookmark ? "تحویل دارو" : "افزودن دارو"}
              </Typography>
              <Check />
            </Box>
            <Box
              width={"15px"}
              height="40px"
              textAlign="center"
              bgcolor="var(--emr-red)"
              px="10px"
              borderRadius={"15px"}
              display="flex"
              alignItems="center"
              justifyContent="space-between"
              sx={{ cursor: "pointer" }}
              onClick={() => {
                // setDeleteModal(true);
                // setDataRowEdit(x.data.patientInfo);
                // console.log(x.data.id);
                if (bookmark) {
                  removeDrugInBookmark(x.data.drugId)
                    .then(() => {
                      setRowData((z) => {
                        let array = [...z];
                        array = array.filter((item) => item.id !== x.data.id);
                        return array;
                      });
                    })
                    .catch(() => {});
                } else {
                  removeAdvice(x.data.id)
                    .then(() => {
                      setRowData((z) => {
                        let array = [...z];
                        array = array.filter((item) => item.id !== x.data.id);
                        return array;
                      });
                    })
                    .catch(() => {});
                }
              }}
            >
              {/* <Typography color="white" fontFamily="Shabnam">
                {"حذف"}
              </Typography> */}
              <TrashIcon color="white" />
            </Box>
            {!bookmark && (
              <Box
                width={"15px"}
                height="40px"
                textAlign="center"
                bgcolor="var(--emr-blue)"
                px="10px"
                borderRadius={"15px"}
                display="flex"
                alignItems="center"
                justifyContent="space-between"
                sx={{ cursor: "pointer" }}
                onClick={() => {
                  // setDeleteModal(true);
                  // setDataRowEdit(x.data.patientInfo);
                  // console.log(x.data);
                  bookmarkDrug(x.data.drugId, {
                    howToUses: x.data.howToUse,
                    amountOfUses: x.data.amountOfUse,
                    useTimes: x.data.useTime,
                  })
                    .then(() => {
                      toast.success("منتخب شد");
                      // setRowData((z) => {
                      //   let array = [...z];
                      //   array = array.filter((item) => item.id !== x.data.id);
                      //   return array;
                      // });
                    })
                    .catch(() => {});
                }}
              >
                <BookmarkIcon color="white" />
              </Box>
            )}
          </Box>
        );
      },
    },
  ]);

  const defaultColDef = useMemo(() => ({
    filter: true,
    editable: true,
  }));
  //   console.log(rowData);
  return (
    <>
      {!parvandeh && (
        <Box bgcolor={"white"} p="15px 10px " mb="-15px" mt="20px">
          <Typography color={"var(--emr-darkblue)"} fontWeight="bold">
            {notDelivered
              ? "جدول بیماران پذیرش نشده"
              : "جدول بیماران پذیرش شده"}
          </Typography>
        </Box>
      )}

      <div className="ag-theme-quartz" style={{ height: 300, marginTop: 10 }}>
        <AgGridReact
          //   pagination={true}
          ref={gridRef}
          rowHeight={60}
          enableRtl={true}
          rowData={rowData}
          columnDefs={parvandeh ? colDefs1 : colDefs}
          defaultColDef={defaultColDef}
          onCellClicked={(e) => {
            if (!parvandeh) {
              //   if (e.value === false || e.value === true) {
              //   } else {
              window.open(
                `/parvandeh?${areaId}&${e.data?.patient?.identifier}&${e.data.patient?.identifierType}&${e.data.patient?.id}&drug`,
                "_blank"
              );
              //   }
            }
          }}
        />
      </div>
    </>
  );
}
